<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div
      id="todo-app"
      class="d-theme-border-grey-light rounded relative overflow-hidden"
    >
      <!-- TOGGLE SIDEBAR BUTTON -->
      <!-- <feather-icon
        class="inline-flex lg:hidden cursor-pointer mr-4"
        icon="MenuIcon"
        @click.stop="toggleFilterSidebar"
      /> -->
      <ais-instant-search
        :search-client="getSearchQuery"
        index-name="instant_search"
        id="algolia-instant-search-demo"
        :stalled-search-delay="200"
      >
        <vs-sidebar
          class="items-no-padding"
          parent="#algolia-instant-search-demo"
          :click-not-close="clickNotClose"
          :hidden-background="clickNotClose"
          v-model="isFilterSidebarActive"
        >
          <component
            :is="scrollbarTag"
            class="todo-scroll-area"
            :settings="settings"
            :key="$vs.rtl"
          >
            <add-edit-new-post
              v-if="getPermission"
              button_type="add_new"
              button_title="Add New"
              :edit_data="item"
              :categories="category_arr"
              :categories_obj="all_categories"
              :all_data="all_items_data"
              @reload_post_data="getCategoryAndFetchData"
              @reload_categories="getCategories"
            />

            <!-- AIS CONFIG -->
            <ais-configure :hits-per-page.camel="12"> </ais-configure>
            <!-- <ais-menu attribute="category" v-if="current_filter != ''">
              <div slot-scope="{ refine }">
                <todo-filters
                  @closeSidebar="toggleTodoSidebar"
                  :categories="all_categories"
                  @reload_category_data="
                    () =>
                      $route.params.filter == 'all'
                        ? refine('')
                        : refine($route.params.filter)
                  "
                  @reload_categories="getCategories"
                ></todo-filters>
                
              </div>
            </ais-menu> -->
            <div>
              <!-- <todo-filters
                @closeSidebar="toggleTodoSidebar"
                :categories="all_categories"
                @reload_category_data="getDataFromAPICall"
                @reload_categories="getCategories"
              ></todo-filters> -->
              <todo-filters
                @closeSidebar="toggleTodoSidebar"
                :categories="all_categories"
                @reload_category_data="setAllItemsData"
                @reload_categories="getCategories"
              ></todo-filters>
            </div>
          </component>
        </vs-sidebar>

        <div class="algolia-header mb-4">
          <div class="flex md:items-end items-center justify-between flex-wrap">
            <!-- TOGGLE SIDEBAR BUTTON -->
            <feather-icon
              class="inline-flex lg:hidden cursor-pointer mr-4"
              icon="MenuIcon"
              @click.stop="toggleFilterSidebar"
            />

            <p
              class="lg:inline-flex hidden font-semibold algolia-filters-label"
            ></p>

            <div class="flex justify-between items-end flex-grow">
              <!-- Stats -->
              <ais-stats v-if="current_filter != ''">
                <p
                  slot-scope="{
                    hitsPerPage,
                    nbPages,
                    nbHits,
                    page,
                    processingTimeMS,
                    query,
                  }"
                  class="font-semibold md:block hidden"
                >
                  {{ nbHits }} results found in {{ processingTimeMS }}ms
                </p>
              </ais-stats>
              <p v-if="data_len != '' && current_filter == ''">
                {{ data_len }} results found
              </p>
              <p v-else></p>

              <div class="flex flex-wrap">
                <!-- SORTING -->
                <!-- <ais-sort-by
                  :items="[
                    { value: 'instant_search', label: 'Featured' },
                    {
                      value: 'instant_search_price_asc',
                      label: 'Lowest Price',
                    },
                    {
                      value: 'instant_search_price_desc',
                      label: 'Highest Price',
                    },
                  ]"
                > 
                  <vs-select
                    :value="currentRefinement"
                    slot-scope="{ items, currentRefinement, refine }"
                    @input="(val) => refine(val)"
                    class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48"
                  >
                    <vs-select-item
                      v-for="item in items"
                      :key="item.value"
                      :value="item.value"
                      :text="item.label"
                    />
                  </vs-select>
                </ais-sort-by> -->

                <!-- ITEM VIEW - GRID/LIST -->
                <div>
                  <vs-icon
                    icon="swap_vert"
                    v-if="$route.params.filter != 'all'"
                    @click="swapEnable"
                    style="font-size: 24px"
                    class="p-2 mr-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                    :class="{
                      'text-primary stroke-current':
                        this.currentItemView == 'item-list-view' &&
                        is_swap_enable == true,
                    }"
                  />
                  <!-- <feather-icon
                    icon="GridIcon"
                    @click="currentItemView = 'item-list-view'"
                    class="p-2 mr-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                    
                  /> -->
                  <feather-icon
                    icon="GridIcon"
                    @click="
                      () => {
                        currentItemView = 'item-grid-view';
                        is_swap_enable = false;
                      }
                    "
                    class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                    :svgClasses="{
                      'text-primary stroke-current':
                        currentItemView == 'item-grid-view',
                    }"
                  />
                  <feather-icon
                    icon="ListIcon"
                    @click="currentItemView = 'item-list-view'"
                    class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                    :svgClasses="{
                      'text-primary stroke-current':
                        currentItemView == 'item-list-view',
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="algolia-content-container" class="relative clearfix">
          <!-- <vs-sidebar
          class="items-no-padding vs-sidebar-rounded background-absolute"
          parent="#algolia-content-container"
          :click-not-close="clickNotClose"
          :hidden-background="clickNotClose"
          v-model="isFilterSidebarActive"
        >

          
        </vs-sidebar> -->

          <!-- RIGHT COL -->
          <div :class="{ 'sidebar-spacer-with-margin': clickNotClose }">
            <!-- SEARCH BAR -->
            <!-- <ais-search-box>
              <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
                <div class="relative mb-8">
                  
                  <vs-input
                    class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                    placeholder="Search here"
                    v-model="current_filter"
                    @input="
                      ($event) => {
                        isSearchStalled = true;
                        is_swap_enable = false;
                        refine($event);
                      }
                    "
                    @keyup.esc="
                      () => {
                        current_filter = '';
                        refine('');
                      }
                    "
                    size="large"
                  />

                 
                  <div
                    slot="submit-icon"
                    class="absolute top-0 right-0 py-4 px-6"
                    v-show="!currentRefinement"
                  >
                    <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" />
                  </div>

                 
                  <div
                    slot="reset-icon"
                    class="absolute top-0 right-0 py-4 px-6"
                    v-show="current_filter"
                  >
                    <feather-icon
                      icon="XIcon"
                      svgClasses="h-6 w-6 cursor-pointer"
                      @click.prevent="
                        () => {
                          current_filter = '';
                          refine('');
                        }
                      "
                    />
                  </div>
                </div>
              </div>
            </ais-search-box> -->
            <!-- <ais-refinement-list attribute="allergy" /> -->
            <!-- SEARCH RESULT -->
            <ais-hits v-if="current_filter != ''">
              <div slot-scope="{ items }">
                <!-- GRID VIEW -->
                <template v-if="currentItemView == 'item-grid-view'">
                  <div class="items-grid-view vx-row match-height">
                    <div
                      class="vx-col lg:w-1/3 sm:w-1/2 w-full"
                      v-for="(item, index) in items"
                      :key="index"
                    >
                      <item-grid-view :item="item" v-show="item.id">
                        <!-- SLOT: ACTION BUTTONS -->
                        <template slot="action-buttons">
                          <div class="flex flex-wrap">
                            <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                            <add-edit-new-post
                              v-if="getPermission"
                              button_type="edit_post"
                              :edit_post_data="item"
                              :categories="category_arr"
                              :all_data="all_items_data"
                              @reload_post_data="getCategoryAndFetchData"
                              @reload_categories="getCategories"
                            />

                            <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                            <add-new-questions
                              v-if="getPermission"
                              :item="item"
                            />
                          </div>
                        </template>
                      </item-grid-view>
                    </div>
                  </div>
                </template>

                <!-- LIST VIEW -->
                <template v-else>
                  <div
                    class="items-list-view mb-base"
                    v-for="(item, index) in items"
                    :key="index"
                  >
                    <item-list-view :item="item">
                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                        <add-edit-new-post
                          v-if="getPermission"
                          button_type="edit_post"
                          :edit_post_data="item"
                          :categories="category_arr"
                          :all_data="all_items_data"
                          @reload_post_data="getCategoryAndFetchData"
                          @reload_categories="getCategories"
                        />
                        <div class="p-2"></div>
                        <add-new-questions v-if="getPermission" :item="item" />
                        <!--                         
                        <div
                          class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer"
                          @click="cartButtonClicked(item)"
                        >
                          <feather-icon
                            icon="ShoppingBagIcon"
                            svgClasses="h-4 w-4"
                          />

                         
                          <span class="text-sm font-semibold ml-2"
                            >Add Questions</span
                          >
                        </div> -->
                      </template>
                    </item-list-view>
                  </div>
                </template>
              </div>
            </ais-hits>
            <ais-hits v-else>
              <div>
                <!-- GRID VIEW -->
                <template v-if="currentItemView == 'item-grid-view'">
                  <div class="items-grid-view vx-row match-height">
                    <div
                      class="vx-col lg:w-1/3 sm:w-1/2 w-full"
                      v-for="(item, index) in items_data"
                      :key="index"
                    >
                      <item-grid-view :item="item" v-show="item.id">
                        <!-- SLOT: ACTION BUTTONS -->
                        <template slot="action-buttons">
                          <div class="flex flex-wrap">
                            <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                            <add-edit-new-post
                              v-if="getPermission"
                              button_type="edit_post"
                              :edit_post_data="item"
                              :categories="category_arr"
                              :all_data="all_items_data"
                              @reload_post_data="getCategoryAndFetchData"
                              @reload_categories="getCategories"
                            />

                            <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                            <add-new-questions
                              v-if="getPermission"
                              :item="item"
                            />
                          </div>
                        </template>
                      </item-grid-view>
                    </div>
                    <infinite-loading
                      v-if="
                        ($route.params.filter != 'all' &&
                          all_health_hacks_data.length == current_page &&
                          all_items_data.length % 12 == 0) ||
                        is_swap_enable
                      "
                      :identifier="identifier"
                      @infinite="getDataFromAPICall"
                    ></infinite-loading>
                  </div>
                </template>

                <!-- LIST VIEW  AND DRAGGABLE ITEMS-->
                <template v-else>
                  <draggable
                    class="cursor-move"
                    v-model="all_items_data"
                    @change="changeItemPosition"
                    :draggable="
                      is_swap_enable == true ? '.items-list-view' : ''
                    "
                    :scroll-sensitivity="250"
                    :fallback-tolerance="1"
                    :force-fallback="true"
                  >
                    <!-- <transition-group> -->
                    <div
                      class="items-list-view mb-4"
                      v-for="(item, index) in is_swap_enable == true
                        ? all_items_data
                        : items_data"
                      :key="index"
                    >
                      <item-list-view
                        :item="item"
                        :is_swap_enable="is_swap_enable"
                        class=""
                      >
                        <!-- SLOT: ACTION BUTTONS -->
                        <template slot="action-buttons">
                          <add-edit-new-post
                            v-if="getPermission && is_swap_enable == false"
                            button_type="edit_post"
                            :edit_post_data="item"
                            :categories="category_arr"
                            :all_data="all_items_data"
                            @reload_post_data="getCategoryAndFetchData"
                            @reload_categories="getCategories"
                          />
                          <div class="p-2"></div>
                          <add-new-questions
                            v-if="getPermission && is_swap_enable == false"
                            :item="item"
                          />
                          <!--                         
                        <div
                          class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer"
                          @click="cartButtonClicked(item)"
                        >
                          <feather-icon
                            icon="ShoppingBagIcon"
                            svgClasses="h-4 w-4"
                          />

                         
                          <span class="text-sm font-semibold ml-2"
                            >Add Questions</span
                          >
                        </div> -->
                        </template>
                      </item-list-view>
                    </div>

                    <!-- </transition-group> -->
                    <infinite-loading
                      v-if="
                        ($route.params.filter != 'all' &&
                          all_health_hacks_data.length == current_page &&
                          all_items_data.length % 12 == 0) ||
                        is_swap_enable
                      "
                      :identifier="identifier"
                      @infinite="getDataFromAPICall"
                    ></infinite-loading>
                  </draggable>
                </template>
              </div>
            </ais-hits>
            <!-- <div v-if="is_health_hacks_data == false" class="no-data-div">
              <b> No data found for {{ category_name_to_get }}</b>
            </div> -->
            <!-- PAGINATION -->
            <ais-pagination v-if="current_filter != ''">
              <div
                slot-scope="{
                  currentRefinement,
                  nbPages,
                  pages,
                  isFirstPage,
                  isLastPage,
                  refine,
                  createURL,
                }"
              >
                <vs-pagination
                  class="pagination-vs"
                  :total="nbPages"
                  :max="7"
                  :value="currentRefinement + 1"
                  @input="
                    (val) => {
                      refine(val - 1);
                    }
                  "
                />
              </div>
            </ais-pagination>
            <div
              v-if="all_health_hacks_data.length != 0 && current_filter == ''"
              class="pagination"
            >
              <vs-pagination
                v-if="is_swap_enable == false"
                class="pagination-vs"
                :total="all_health_hacks_data.length"
                :max="all_health_hacks_data.length"
                :value="0 + 1"
                @input="
                  (val) => {
                    refinePagination(val - 1);
                  }
                "
              />
            </div>
            <div class="blank-space"></div>

            <!-- ALGOLIA LOGO -->
            <!-- <img
              class="flex mt-4 mx-auto h-8"
              src="@/assets/images/pages/eCommerce/Algolia-logo.png"
              alt="algolia-logo"
            /> -->
          </div>
        </div>
      </ais-instant-search>
    </div>
  </div>
</template>

<script>
import {
  AisClearRefinements,
  AisConfigure,
  AisHierarchicalMenu,
  AisHits,
  AisInstantSearch,
  AisNumericMenu,
  AisPagination,
  AisRangeInput,
  AisRatingMenu,
  AisRefinementList,
  AisSearchBox,
  AisSortBy,
  AisMenu,
  AisStats,
} from "vue-instantsearch";
import algoliasearch from "algoliasearch/lite";
import draggable from "vuedraggable";
import TodoAddNew from "../apps/todo/TodoAddNew.vue";
import TodoTask from "../apps/todo/TodoTask.vue";
import TodoFilters from "../apps/todo/TodoFilters.vue";
import TodoEdit from "../apps/todo/TodoEdit.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AddNewQuestions from "../apps/health-hacks/AddQuestions.vue";
import AddEditNewPost from "../apps/health-hacks/AddEditNewPost.vue";
import DataProvider from "../../services/data-provider";
import Constant from "../../services/constant";
import vSelect from "vue-select";
import { bus } from "../../main";
import AddEditNewQuestionnaire from "../apps/health-tracker/AddEditNewQuestionnaire.vue";
import firebase from "firebase/app";
import _ from "lodash";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    ItemGridView: () => import("../apps/eCommerce/components/ItemGridView.vue"),
    ItemListView: () => import("../apps/eCommerce/components/ItemListView.vue"),
    AisClearRefinements,
    AisConfigure,
    AisHierarchicalMenu,
    AisHits,
    AisInstantSearch,
    AisNumericMenu,
    AisPagination,
    AisRangeInput,
    AisRatingMenu,
    AisRefinementList,
    AisSearchBox,
    AisSortBy,
    AisMenu,
    AisStats,
    TodoAddNew,
    TodoTask,
    TodoFilters,
    TodoEdit,
    draggable,
    VuePerfectScrollbar,
    AddNewQuestions,
    "v-select": vSelect,
    AddEditNewPost,
    AddEditNewQuestionnaire,
    InfiniteLoading,
  },
  data() {
    return {
      current_filter: "",
      searchQuery: "",
      activePrompt: false,
      edit_id: "",
      data_len: "",
      item: "",
      current_page: 1,
      identifier: true,
      user_permissions: {},
      user_role: "",
      category_name_to_get: "",
      is_health_hacks_data: true,
      taskLocal: {
        category: "",
        video_url: "",
        video_title: "",
        // thumbnail: "",
        questions: [],
      },
      edit_data: false,
      is_swap_enable: false,
      offset_value: 0, // For infinite scroll of list items
      // searchClient,
      all_categories: [],
      category_arr: [],
      items_data: [],
      all_items_data: [],
      all_health_hacks_data: [],
      // Filter Sidebar
      isFilterSidebarActive: true,
      clickNotClose: true,
      isSidebarActive: true,
      currentItemView: "item-grid-view",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      numericItems: [
        { label: "All" },
        { label: "<= $10", end: 10 },
        { label: "$10 - $100", start: 10, end: 100 },
        { label: "$100 - $500", start: 100, end: 500 },
        { label: ">= $500", start: 500 },
      ],
      algoliaCategories: [
        "hierarchicalCategories.lvl0",
        "hierarchicalCategories.lvl1",
        "hierarchicalCategories.lvl2",
        "hierarchicalCategories.lvl3",
      ],
    };
  },
  computed: {
    taskTags() {
      return this.$store.state.todo.taskTags;
    },
    getSearchQuery() {
      const algoliaClient = algoliasearch(
        "latency",
        "6be0576ff61c053d5f9a3225e2a90f76"
        //  "CG7GZWX54I",
        // "400a5a7e321f9a6f0b3dfd25b4168871",
        // "5EQJRO2ZM1",
        // "a77f72541b2116f6dd0ae6be0fc67c0d",
        // { _useCache: false }
      );
      console.log(algoliaClient);
      return algoliaClient;
    },
    validateForm() {
      return !this.errors.any() && this.taskLocal.category !== "";
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    getPermission() {
      console.log(this.$route);
      if (this.user_role == "Owner") return true;
      if (this.user_permissions[this.$route.name]) {
        console.log(this.user_permissions[this.$route.name]);
        return this.user_permissions[this.$route.name]["write"];
      }
    },
    getItems() {
      this.$store.getters.healthHacksData;
    },
    toValue() {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max,
      ];
    },

    // GRID VIEW
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    isInWishList() {
      return (itemId) => this.$store.getters["eCommerce/isInWishList"](itemId);
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  mounted() {
    DataProvider.getCurrentAuthUser().then((res) => {
      console.log(res);
      this.user_role = res.claims.role;
      DataProvider.getData("users", res.claims.user_id).then(
        (data) => {
          console.log("data", data.permissions);
          this.user_permissions = data.permissions;
          console.log(this.user_permissions);
        },
        (err) => {}
      );
    });
    this.getCategories();
  },
  watch: {
    todoFilter() {
      console.log("todoFilter", this.$route.params.filter);
      const scroll_el = this.$refs.taskListPS.$el || this.$refs.taskListPS;
      scroll_el.scrollTop = 0;

      this.toggleTodoSidebar();

      // Fetch Tasks
      const filter = this.$route.params.filter;
      this.$store.dispatch("todo/fetchTasks", { filter });
      this.$store.commit("todo/UPDATE_TODO_FILTER", filter);
    },
    windowWidth() {
      this.setSidebarWidth();
    },
  },
  methods: {
    changeItemPosition(event) {
      console.log(event);
      console.log("new Data:", event.moved.newIndex, event.moved.oldIndex);
      console.log(event);
      this.$vs.loading();
      let old_item;
      let new_item;
      console.log("this.all_items_data:", this.all_items_data);

      console.log(event.moved.newIndex == this.all_items_data.length - 1);
      if (event.moved.newIndex == this.all_items_data.length - 1) {
        new_item = this.all_items_data[event.moved.newIndex];
        console.log("old item index", event.moved.newIndex - 1);
        old_item = this.all_items_data[event.moved.newIndex - 1];
      } else {
        new_item = this.all_items_data[event.moved.newIndex];
        old_item = this.all_items_data[event.moved.newIndex + 1];
      }
      // if (new_item == undefined || old_item == undefined) {
      if (new_item == undefined) {
        new_item = this.all_items_data[this.all_items_data.length - 1];
      }
      if (old_item == undefined) {
        old_item = this.all_items_data[this.all_items_data.length - 2];
      }
      // this.$vs.loading.close();
      // this.$vs.notify({
      //   color: "warning",
      //   title: "Something went wrong. Try again!",
      // });
      // this.setAllItemsData();

      // } else {
      console.log("new_item", new_item);
      console.log("old_item", old_item);
      const new_category = new_item.category.split(" ").join("_");
      let old_category = old_item.category.split(" ").join("_");
      let index = 0;
      if (new_category != old_category) {
        this.all_items_data.filter((item) => {
          if (item.category == new_item.category) {
            index = index + 1;
          }
        });
        console.log(index);
        this.all_items_data.filter((item) => {
          if (item.order == index) {
            old_item = item;
            old_category = item.category.split(" ").join("_");
          }
        });
      }
      console.log("new::", new_item);
      console.log("old::", old_item);
      const old_id = old_item.id;
      const new_item_data = { order: old_item.order };
      const old_item_data = { order: new_item.order };
      const new_id = new_item.id;

      DataProvider.setItemsOrder(
        old_id,
        old_item_data,
        old_category,
        new_id,
        new_item_data,
        new_category
      ).then(
        (res) => {
          console.log(res);
          // this.$vs.loading.close();
          // if (event.moved.newIndex >= this.all_items_data.length - 1) {
          // this.setAllItemsData();
          // } else {
          this.getDataFromAPICall("", true);
          // }
        },
        (err) => {
          this.$vs.loading.close();
        }
      );
      // }
    },
    swapEnable() {
      console.log("swapEnable");
      this.currentItemView = "item-list-view";
      this.is_swap_enable = true;
    },
    searchFunction(helper) {
      console.log(helper);
      console.log("todoFilter", this.$route.params.filter);
      const filter =
        this.$route.params.filter == "all" ? "" : this.$route.params.filter;
      const page = helper.getPage(); // Retrieve the current page

      helper
        .setQuery(filter) // this call resets the page
        .setPage(page) // we re-apply the previous page
        .search();
      // if (helper.state.query) {
      //   helper.search();
      // }
      // else{
      //     helper.search();
      // }
    },
    updateSearchQuery(event) {
      console.log(event);
      console.log(this.category_arr);
      const small_string = event.toLowerCase();
      const value =
        small_string.charAt(0).toUpperCase() + small_string.slice(1);
      if (event.length >= 3) {
        DataProvider.searchQueryInFirestore(this.category_arr, event).then(
          (res) => {
            console.log(JSON.stringify(res));
            if (res.length != 0) {
              this.items_data = [];
              this.data_len = res.length;
              this.arrangeData(res);
            }
          }
        );
      } else if (event.length == 0) {
        this.items_data = [];
        this.data_len = this.all_items_data.length;
        this.arrangeData(this.all_items_data);
      }

      // this.gridApi.setQuickFilter(val);
    },
    refinePagination(data) {
      console.log(data);
      this.current_page = data + 1;
      this.items_data = this.all_health_hacks_data[data];
    },
    // clearFields() {
    //   Object.assign(this.taskLocal, {
    //     category: "",
    //     video_url: "",
    //     video_title: "",
    //     thumbnail: "",
    //   });
    //   this.edit_data = false;
    //   this.edit_id = "";
    // },
    // addTodo() {
    //   console.log(this.taskLocal);

    //   this.$validator.validateAll().then((result) => {
    //     if (result) {
    //       console.log(result);
    //       if (this.edit_data == false) {
    //         DataProvider.postDataToCloud("/health_hacks", this.taskLocal).then(
    //           (data) => {
    //             console.log("Data:", data);
    //             this.getCategoryAndFetchData();
    //             // this.clearFields();
    //           }
    //         );
    //       } else {
    //         DataProvider.updateFirestoreData(
    //           "/health_hacks",
    //           this.taskLocal,
    //           this.edit_id
    //         ).then((data) => {
    //           console.log("Data:", data);
    //           this.getCategoryAndFetchData();
    //           // this.clearFields();
    //         });
    //       }

    //       // this.$store.dispatch(
    //       //   "todo/addTask",
    //       //   Object.assign({}, this.taskLocal)
    //       // );
    //     }
    //   });
    // },
    openNew() {
      this.activePrompt = true;
    },
    editData(data) {
      console.log(data);
      this.activePrompt = true;
      this.edit_data = true;
      this.edit_id = data.id;
      this.taskLocal.category = data.category;
      this.taskLocal.video_url = data.video_url;
      this.taskLocal.video_title = data.video_title;
      this.taskLocal.thumbnail = data.thumbnail;
      this.taskLocal.questions = data.questions;
    },
    setAllItemsData() {
      // this.all_items_data = [];
      // this.items_data = [];
      // this.all_health_hacks_data=[]
      this.$vs.loading();
      // if(this.is_swap_enable==false){
      this.identifier = !this.identifier;
      // }
      this.getDataFromAPICall("", true);
    },
    getDataFromAPICall($state, is_reload) {
      console.log("getDataFromAPICall", is_reload);
      this.category_name_to_get = this.$route.params.filter
        .split(" ")
        .join("_");
      console.log($state);
      console.log(this.category_name_to_get);

      if (!$state && this.category_name_to_get == "all") {
        console.log("getDataFromAPICall");
        if (this.category_name_to_get == "all") {
          this.is_swap_enable = false;
          // DataProvider.getFirestoreAllHealthHacksData(this.category_arr).then(
          //   (data) => {
          DataProvider.getDataFromCloud(
            "/health_hacks_all/" + JSON.stringify(this.category_arr)
          ).then((data) => {
            console.log("health_hacks_all data:", data);
            let items_data = data.data;
            this.all_items_data = data.data;
            this.data_len = items_data.length;
            if (this.data_len == 0) {
              this.is_health_hacks_data = false;
            }
            if (data.data) {
              this.arrangeData(data.data);
            }
            // console.log("health_hacks_all data:", data);
            // let items_data = data;
            // this.all_items_data = data;
            // this.data_len = items_data.length;
            // if (this.data_len == 0) {
            //   this.is_health_hacks_data = false;
            // }
            // if (data) {
            //   this.arrangeData(data);
            // }

            this.$vs.loading.close();
          });
        } else {
          DataProvider.getDataFromCloud(
            category_name_to_get == "all"
              ? "/health_hacks_all"
              : "/health_hacks/" + this.category_name_to_get
          ).then((data) => {
            console.log("data:::", data);
            let items_data = data.data;
            this.all_items_data = data.data;
            this.data_len = items_data.length;
            if (this.data_len == 0) {
              this.is_health_hacks_data = false;
            }
            this.arrangeData(items_data);

            this.$vs.loading.close();
          });
        }
      } else {
        if (this.category_name_to_get == "all") {
          DataProvider.getFirestoreAllHealthHacksData(this.category_arr).then(
            (data) => {
              console.log("data:", data);
              let items_data = data;
              this.all_items_data = data;
              this.data_len = items_data.length;
              if (this.data_len == 0) {
                this.is_health_hacks_data = false;
              }
              if (data) {
                this.arrangeData(data);
              }
              this.$vs.loading.close();
            }
          );
        } else {
          console.log(this.all_items_data);
          this.offset_value = this.all_items_data.length;
          if (is_reload == true) {
            this.offset_value = 0;
            // this.all_items_data=[]
          }
          DataProvider.getOffsetDataFromCloud(
            "/health_hacks/" + this.category_name_to_get,
            this.offset_value
          ).then((data) => {
            console.log("data:::##", data);

            if (data.data.length != 0) {
              if ($state) {
                $state.loaded();
              }
              // this.identifier = !this.identifier;
              let items_data = data.data;
              if (is_reload == undefined) {
                const all_concat_data = this.all_items_data.concat(items_data);
                this.all_items_data = all_concat_data;
                this.data_len = this.all_items_data.length;
                this.arrangeData(this.all_items_data);
              } else {
                if (is_reload == true) {
                  this.all_items_data = items_data;
                  this.data_len = items_data.length;
                  this.arrangeData(items_data);
                }
              }
              if (this.data_len == 0) {
                this.is_health_hacks_data = false;
              }
            } else {
              if ($state) {
                $state.complete();
              }
            }

            this.$vs.loading.close();
          });
        }
      }
    },
    arrangeData(items_data) {
      var temparray = [],
        chunk = Constant.item_per_page_value;
      var final_array = [];
      let len = this.data_len;
      for (let i = 1; i <= len; i++) {
        temparray.push(items_data[i - 1]);
        if (i % chunk == 0) {
          final_array.push(temparray);
          temparray = [];
        } else if (i == len) {
          final_array.push(temparray);
          temparray = [];
        }
      }
      console.log(final_array);
      this.all_health_hacks_data = final_array;
      if (final_array.length != 0) {
        this.items_data = final_array[0];
        this.$store.commit("setHealthHacksData", final_array);
      }
    },
    getCategoryAndFetchData() {
      console.log("getCategoryAndFetchData");

      this.category_name_to_get;
      if (this.category_arr.length != 0) {
        this.category_name_to_get = "all";
      } else {
        this.category_name_to_get = "asthma";
      }
      // console.log(this.category_name_to_get);
      if (this.$route.params.filter == this.category_name_to_get) {
      } else {
        this.$router.push("/pages/health-hacks/" + this.category_name_to_get);
      }
      this.getDataFromAPICall("", true);
    },

    getCategories() {
      this.$vs.loading();
      let categories_obj_arr = [];
      let categories_arr = [];
      DataProvider.getDataFromCloud("/health_hacks_categories").then((data) => {
        console.log("data", data);

        if (data.data) {
          this.category_arr = data.data;

          this.category_arr.filter(async (itm, i) => {
            await DataProvider.getCategoryMetaData(itm).then((meta_data) => {
              // console.log(meta_data);
              categories_obj_arr.push({
                category: itm,
                is_edit: false,
                ...meta_data,
              });
            });
            if (i == this.category_arr.length - 1) {
              console.log(i == this.category_arr.length - 1);
              this.all_categories = categories_obj_arr.sort((a, b) => {
                return a.collection_order - b.collection_order;
              });

              console.log("categories_obj_arr:", categories_obj_arr);
              // this.all_categories = categories_obj_arr;
              categories_obj_arr.filter((itm, index) => {
                categories_arr.push(itm.category);
                if (index == categories_obj_arr.length - 1) {
                  this.category_arr = categories_arr;
                }
              });
              console.log(
                "this.all_categories",
                JSON.stringify(this.all_categories)
              );
              this.getCategoryAndFetchData("");
            }
          });

          // this.all_categories = this.all_categories.sort((a, b) =>
          //   b.collection_order > a.collection_order
          //     ? 1
          //     : a.collection_order > b.collection_order
          //     ? -1
          //     : 0
          // );
          // this.$vs.loading.close();
          // setTimeout(()=>{

          // }, 300);
        } else {
          // this.$vs.loading.close();
          this.getCategoryAndFetchData();
        }
      });
    },
    toggleTodoSidebar(value = false) {
      if (!value && this.clickNotClose) return;
      this.isSidebarActive = value;
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false;
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true;
      }
    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar() {
      if (this.clickNotClose) return;
      this.isFilterSidebarActive = !this.isFilterSidebarActive;
    },
    toggleItemInWishList(item) {
      this.$store.dispatch("eCommerce/toggleItemInWishList", item);
    },
    additemInCart(item) {
      this.$store.dispatch("eCommerce/additemInCart", item);
    },
    cartButtonClicked(item) {
      this.isInCart(item.id)
        ? this.$router.push("/apps/eCommerce/checkout").catch(() => {})
        : this.additemInCart(item);
    },
  },
  created() {
    this.setSidebarWidth();
    bus.$on("edit_item_data", (data) => {
      console.log(data);
      this.editData(data);
    });
  },
};
</script>


<style lang="scss">
.pagination-vs {
  width: 46% !important;
}
.blank-space {
  height: 30vh;
}
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  .no-data-div {
    height: 500px;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  #algolia-content-container {
    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: 0.5rem;
    }

    .vs-sidebar--items {
      border-radius: 0.5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}
</style>

